import { render, staticRenderFns } from "./ReferralsModal.vue?vue&type=template&id=6d07a280&scoped=true&"
import script from "./ReferralsModal.vue?vue&type=script&lang=ts&"
export * from "./ReferralsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralsModal.vue?vue&type=style&index=0&id=6d07a280&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07a280",
  null
  
)

export default component.exports